/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Seo_Endpoint_Price_SentenceInputs */

const en_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It costs ${i?.price}, in US dollars with no subscription and no monthly minimum.`)
};

const zh_hans1_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`费用：${i?.price}，以美元计价，无需订阅，也没有每月最低消费。`)
};

const pt_br2_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Custa ${i?.price}, em dólares, sem assinatura e sem mínimo mensal.`)
};

const es_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cuesta ${i?.price}, en dólares estadounidenses, sin suscripción y sin mínimo mensual.`)
};

const fr_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elle coûte ${i?.price}, en dollars US, sans abonnement et sans minimum mensuel.`)
};

const de_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sie kostet ${i?.price}, in US-Dollar, ohne Abo und ohne monatliches Minimum.`)
};

const ru_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Это стоит ${i?.price}, в долларах США, без подписки и без ежемесячного минимума.`)
};

const it_seo_endpoint_price_sentence = /** @type {(inputs: Seo_Endpoint_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Costa ${i?.price}, in dollari statunitensi, senza abbonamento e senza minimo mensile.`)
};

/**
* | output |
* | --- |
* | "It costs {price}, in US dollars with no subscription and no monthly minimum." |
*
* @param {Seo_Endpoint_Price_SentenceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_price_sentence = /** @type {((inputs: Seo_Endpoint_Price_SentenceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Price_SentenceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_price_sentence(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_price_sentence(inputs)
	if (locale === "es") return es_seo_endpoint_price_sentence(inputs)
	if (locale === "fr") return fr_seo_endpoint_price_sentence(inputs)
	if (locale === "de") return de_seo_endpoint_price_sentence(inputs)
	if (locale === "ru") return ru_seo_endpoint_price_sentence(inputs)
	if (locale === "it") return it_seo_endpoint_price_sentence(inputs)
	return en_seo_endpoint_price_sentence(inputs)
});